jQuery(function ($) {

	// MOBILE MENU

	$('.safirToggleMenu').on("click", function() {
		$("body").addClass("hamburgerActive");
		$("#hamburgermenu").stop().animate({"left": "0"}, 200);
		$('#mobileOverlay').fadeIn();
	});

	$('#mobileOverlay, #hamburgermenu span.close, #hamburgermenu a[href!="#"]').on("click", function() {
		closeHamburger();
	});

	function closeHamburger() {
		$("#hamburgermenu").stop().animate({"left": "-300px"}, 200, function() {
			$('#mobileOverlay').fadeOut();
			$("body").removeClass("hamburgerActive");
			$("#hamburgermenu").scrollTop(0);
			$("#hamburgermenu .arrow").removeClass("toggle");
			$("#hamburgermenu .sub-menu").slideUp();
		});
	}

	$("#mobilemenu .menu-item-has-children>a[href='#'], #mobilemenu .menu-item-has-children>span.arrow").on("click", function (event) {
		event.preventDefault();
		submenu = $(this).closest("li").find(">.sub-menu");
		arrow = $(this).closest("li").find(">.arrow");
		submenu.slideToggle();
		arrow.toggleClass("toggle");
	});

// THEME DOWNLOAD

	$(".safirLicences td.dosya .indirButton").on("click", function (e) {
		e.preventDefault();
		$(".safirLicences td.dosya .download-popup").fadeOut();
		if ($(this).hasClass("active") == false) {
			$(".safirLicences td.dosya .indirButton").removeClass("active");
			$(this).addClass("active");
			$(this).next().slideDown();
		} else {
			$(".safirLicences td.dosya .indirButton").removeClass("active");
		}
	});

	$(".safirLicences td.dosya .download-popup a").on("click", function () {
		$(".safirLicences td.dosya .indirButton").removeClass("active");
		$(".safirLicences td.dosya .download-popup").fadeOut();
	});

	$(document).mouseup(function(e) {
		var container = $(".safirLicences td.dosya");
		if (!container.is(e.target) && container.has(e.target).length === 0) {
			$(".safirLicences td.dosya .indirButton").removeClass("active");
			$(".safirLicences td.dosya .download-popup").fadeOut(100);
		}
	});


// LİSANS KOPYALAMA

	function copyClipboard(element) {
		var elm = document.getElementById(element);
		var selection = window.getSelection();
		var range = document.createRange();
		range.selectNodeContents(elm);
		selection.removeAllRanges();
		selection.addRange(range);
		document.execCommand("Copy");
	}


	$(".safirLicences td.dosya .download-popup .copy").click(function (e) {
		e.preventDefault();
		copyClipboard($(this).closest("td").prev().attr("id"));
		code = $(this).closest("td").prev().html();
		Swal.fire({
			title: "Lisans Kodu Kopyalandı",
			text: code,
			icon: "success",
			confirmButtonText: 'Kapat'
		});
	});

	$(".safirLicences td.code").click(function () {
		copyClipboard($(this).attr("id"));
		code = $(this).html();
		Swal.fire({
			title: "Lisans Kodu Kopyalandı",
			text: code,
			icon: "success",
			confirmButtonText: 'Kapat'
		});
	});

	// EXTERNAL LINKS

	$("a[rel^='external']").attr("target", "_blank");

	// ARRANGEMENTS

	$('#billing_email_field').removeClass('form-row-first').addClass('form-row-wide');
	$('#billing_email_field label').html('Email adresiniz');
	$('body.desktop textarea#order_comments').css('height', '133px');

	// FANCYBOX

	$('.gallery a img').each(function () {
		$(this).parent().attr('title', $(this).attr('alt'));
	});
	$('.gallery a').attr('rel', 'group').fancybox();
	$('#productContent .wp-block-gallery a').attr('rel', 'group').fancybox();

	// REFERENCES

	$("#references .thumb").hover(function () {
		$("#references .thumb span.icon").remove();
		$(this).find("a").append('<span class="icon"></span>');
		$("#references .thumb span.icon").fadeOut().css("display", "none").fadeIn();
	}, function () {
		$("#references .thumb span.icon").fadeOut()
	});

	// MENU

	$(window).resize(function () {
		if ($(window).width() > 600) {
			$('#menu .container>ul').css('display', 'table-row');
			$('.safirToggleMenu').removeClass('open');
		} else if ($('.safirToggleMenu').hasClass('open') == false) {
			$('#menu .container>ul').css('display', 'none');
		}
	});

	// ASIDE

	if ($("body").hasClass("admin-bar")) {
		safirAdditionalMarginTop = 137;
	} else {
		safirAdditionalMarginTop = 105;
	}

	!function (a) { a.fn.theiaStickySidebar = function (b) { var c = { containerSelector: "", additionalMarginTop: safirAdditionalMarginTop, additionalMarginBottom: 20, updateSidebarHeight: !0, minWidth: 0 }; b = a.extend(c, b), b.additionalMarginTop = parseInt(b.additionalMarginTop) || 0, b.additionalMarginBottom = parseInt(b.additionalMarginBottom) || 0, a("head").append(a('<style>.theiaStickySidebar:after {content: ""; display: table; clear: both;}</style>')), this.each(function () { function f() { c.fixedScrollTop = 0, c.sidebar.css({ "min-height": "1px" }), c.stickySidebar.css({ position: "static", width: "" }) } function g(b) { var c = b.height(); return b.children().each(function () { c = Math.max(c, a(this).height()) }), c } var c = {}; c.sidebar = a(this), c.options = b || {}, c.container = a(c.options.containerSelector), 0 == c.container.size() && (c.container = c.sidebar.parent()), c.sidebar.parents().css("-webkit-transform", "none"), c.sidebar.css({ position: "relative", overflow: "visible", "-webkit-box-sizing": "border-box", "-moz-box-sizing": "border-box", "box-sizing": "border-box" }), c.stickySidebar = c.sidebar.find(".theiaStickySidebar"), 0 == c.stickySidebar.length && (c.sidebar.find("script").remove(), c.stickySidebar = a("<div>").addClass("theiaStickySidebar").append(c.sidebar.children()), c.sidebar.append(c.stickySidebar)), c.marginTop = parseInt(c.sidebar.css("margin-top")), c.marginBottom = parseInt(c.sidebar.css("margin-bottom")), c.paddingTop = parseInt(c.sidebar.css("padding-top")), c.paddingBottom = parseInt(c.sidebar.css("padding-bottom")); var d = c.stickySidebar.offset().top, e = c.stickySidebar.outerHeight(); c.stickySidebar.css("padding-top", 1), c.stickySidebar.css("padding-bottom", 1), d -= c.stickySidebar.offset().top, e = c.stickySidebar.outerHeight() - e - d, 0 == d ? (c.stickySidebar.css("padding-top", 0), c.stickySidebarPaddingTop = 0) : c.stickySidebarPaddingTop = 1, 0 == e ? (c.stickySidebar.css("padding-bottom", 0), c.stickySidebarPaddingBottom = 0) : c.stickySidebarPaddingBottom = 1, c.previousScrollTop = null, c.fixedScrollTop = 0, f(), c.onScroll = function (c) { if (c.stickySidebar.is(":visible")) { if (a("body").width() < c.options.minWidth) return void f(); if (c.sidebar.outerWidth(!0) + 50 > c.container.width()) return void f(); var d = a(document).scrollTop(), e = "static"; if (d >= c.container.offset().top + (c.paddingTop + c.marginTop - c.options.additionalMarginTop)) { var m, h = c.paddingTop + c.marginTop + b.additionalMarginTop, i = c.paddingBottom + c.marginBottom + b.additionalMarginBottom, j = c.container.offset().top, k = c.container.offset().top + g(c.container), l = 0 + b.additionalMarginTop, n = c.stickySidebar.outerHeight() + h + i < a(window).height(); m = n ? l + c.stickySidebar.outerHeight() : a(window).height() - c.marginBottom - c.paddingBottom - b.additionalMarginBottom; var o = j - d + c.paddingTop + c.marginTop, p = k - d - c.paddingBottom - c.marginBottom, q = c.stickySidebar.offset().top - d, r = c.previousScrollTop - d; "fixed" == c.stickySidebar.css("position") && (q += r), q = r > 0 ? Math.min(q, l) : Math.max(q, m - c.stickySidebar.outerHeight()), q = Math.max(q, o), q = Math.min(q, p - c.stickySidebar.outerHeight()); var s = c.container.height() == c.stickySidebar.outerHeight(); e = (s || q != l) && (s || q != m - c.stickySidebar.outerHeight()) ? d + q - c.sidebar.offset().top - c.paddingTop <= b.additionalMarginTop ? "static" : "absolute" : "fixed" } if ("fixed" == e) c.stickySidebar.css({ position: "fixed", width: c.sidebar.width(), top: q, left: c.sidebar.offset().left + parseInt(c.sidebar.css("padding-left")) }); else if ("absolute" == e) { var t = {}; "absolute" != c.stickySidebar.css("position") && (t.position = "absolute", t.top = d + q - c.sidebar.offset().top - c.stickySidebarPaddingTop - c.stickySidebarPaddingBottom), t.width = c.sidebar.width(), t.left = "", c.stickySidebar.css(t) } else "static" == e && f(); "static" != e && 1 == c.options.updateSidebarHeight && c.sidebar.css({ "min-height": c.stickySidebar.outerHeight() + c.stickySidebar.offset().top - c.sidebar.offset().top + c.paddingBottom }), c.previousScrollTop = d } }, c.onScroll(c), a(document).scroll(function (a) { return function () { a.onScroll(a) } }(c)), a(window).resize(function (a) { return function () { a.stickySidebar.css({ position: "static" }), a.onScroll(a) } }(c)) }) } }(jQuery);

	$('body.desktop aside').theiaStickySidebar();

	// HASH

	$("aside .safirButton.yorum").on("click", function () {
		$('#tab-reviews').show();
		$('li.reviews_tab a').trigger('click');
	});

	$("aside .safirButton.para").on("click", function () {
		$('#tab-payment_tab').show();
		$('li.payment_tab_tab a').trigger('click');
	});

	// DESTEK FORM

	$("#destekForm .wpcf7-email").attr("value", ($(".hiddenCustomerEmail").text()));


	// SİPARİŞ FORMU

	/*
	$("#place_order").attr("disabled", "disabled");

	$('input#terms').change(function() {
		$('#place_order').attr('disabled', $('input#terms:checked').length == 0);
		console.log("tewst");
	});
	*/

	$(".woocommerce form.checkout input, .woocommerce form.checkout select, .woocommerce form.checkout textarea").focus(function () {
		$(this).parent().prev().addClass("focused");
	});

	$(".woocommerce form.checkout input, .woocommerce form.checkout select, .woocommerce form.checkout textarea").blur(function () {
		$(this).parent().prev().removeClass("focused");
	});

	//$('<div style="line-height:20px; color:#ed0303; margin-bottom:10px;">Önemli Uyarı: Domain adresiniz daha sonra değiştirilememektedir. Sipariş onayı ile bunu kabul etmiş sayılırsınız ve domain değişimi talebinde bulunamazsınız.</div><div style="line-height:20px; color:#676767; margin-bottom:10px;">Temanın kullanılacağı domain adresiniz ve kurulum bilgilerini aşağıya giriniz. Eğer sitenizde içerik yoksa demo içerik için host paneli, içerik varsa FTP ve admin bilgisini giriniz.</div>').insertAfter("label.withinstall")

	//$('<div style="line-height:20px; color:#ed0303; margin-bottom:10px;">Önemli Uyarı: Domain adresiniz daha sonra değiştirilememektedir. Sipariş onayı ile bunu kabul etmiş sayılırsınız ve domain değişimi talebinde bulunamazsınız.</div><div style="line-height:20px; color:#676767; margin-bottom:10px;">Temanın kullanılacağı domain adresinizi aşağıya giriniz.</div>').insertAfter("label.noinstall")

	//$('<span>(<a href="https://safirtema.com/?p=162">Buraya tıklayarak</a> kurulum hizmeti de satın alabilirsiniz.)</span>').appendTo("label.noinstall");


	setInterval(function () {
		var items = ["#billing_address_1", "#billing_company", "#billing_first_name", "#billing_last_name", "#billing_city", "#billing_vd"];
		items.forEach(siparisHarfDonusumu);
	}, 1000);

	function siparisHarfDonusumu(item, index) {
		if ($(item).length > 0) {
			var arr = $(item).val().split(' ');
			var result = '';
			var ilkHarf = '';
			for (var x = 0; x < arr.length; x++) {
				if (arr[x].substring(0, 1) == "i") {
					ilkHarf = "İ";
				} else if (arr[x].substring(0, 1) == "ı") {
					ilkHarf = "I";
				} else {
					ilkHarf = arr[x].substring(0, 1).toUpperCase();
				}
				result += ilkHarf + arr[x].substring(1) + ' ';
			}
			$(item).val(result.substring(0, result.length - 1));
		}
	}

	// LAZYLOAD

	!function (t, e) { "use strict"; function r(r, a, i, u, l) { function f() { L = t.devicePixelRatio > 1, i = c(i), a.delay >= 0 && setTimeout(function () { s(!0) }, a.delay), (a.delay < 0 || a.combined) && (u.e = v(a.throttle, function (t) { "resize" === t.type && (w = B = -1), s(t.all) }), u.a = function (t) { t = c(t), i.push.apply(i, t) }, u.g = function () { return i = n(i).filter(function () { return !n(this).data(a.loadedName) }) }, u.f = function (t) { for (var e = 0; e < t.length; e++) { var r = i.filter(function () { return this === t[e] }); r.length && s(!1, r) } }, s(), n(a.appendScroll).on("scroll." + l + " resize." + l, u.e)) } function c(t) { var i = a.defaultImage, o = a.placeholder, u = a.imageBase, l = a.srcsetAttribute, f = a.loaderAttribute, c = a._f || {}; t = n(t).filter(function () { var t = n(this), r = m(this); return !t.data(a.handledName) && (t.attr(a.attribute) || t.attr(l) || t.attr(f) || c[r] !== e) }).data("plugin_" + a.name, r); for (var s = 0, d = t.length; s < d; s++) { var A = n(t[s]), g = m(t[s]), h = A.attr(a.imageBaseAttribute) || u; g === N && h && A.attr(l) && A.attr(l, b(A.attr(l), h)), c[g] === e || A.attr(f) || A.attr(f, c[g]), g === N && i && !A.attr(E) ? A.attr(E, i) : g === N || !o || A.css(O) && "none" !== A.css(O) || A.css(O, "url('" + o + "')") } return t } function s(t, e) { if (!i.length) return void (a.autoDestroy && r.destroy()); for (var o = e || i, u = !1, l = a.imageBase || "", f = a.srcsetAttribute, c = a.handledName, s = 0; s < o.length; s++)if (t || e || A(o[s])) { var g = n(o[s]), h = m(o[s]), b = g.attr(a.attribute), v = g.attr(a.imageBaseAttribute) || l, p = g.attr(a.loaderAttribute); g.data(c) || a.visibleOnly && !g.is(":visible") || !((b || g.attr(f)) && (h === N && (v + b !== g.attr(E) || g.attr(f) !== g.attr(F)) || h !== N && v + b !== g.css(O)) || p) || (u = !0, g.data(c, !0), d(g, h, v, p)) } u && (i = n(i).filter(function () { return !n(this).data(c) })) } function d(t, e, r, i) { ++z; var o = function () { y("onError", t), p(), o = n.noop }; y("beforeLoad", t); var u = a.attribute, l = a.srcsetAttribute, f = a.sizesAttribute, c = a.retinaAttribute, s = a.removeAttribute, d = a.loadedName, A = t.attr(c); if (i) { var g = function () { s && t.removeAttr(a.loaderAttribute), t.data(d, !0), y(T, t), setTimeout(p, 1), g = n.noop }; t.off(I).one(I, o).one(D, g), y(i, t, function (e) { e ? (t.off(D), g()) : (t.off(I), o()) }) || t.trigger(I) } else { var h = n(new Image); h.one(I, o).one(D, function () { t.hide(), e === N ? t.attr(C, h.attr(C)).attr(F, h.attr(F)).attr(E, h.attr(E)) : t.css(O, "url('" + h.attr(E) + "')"), t[a.effect](a.effectTime), s && (t.removeAttr(u + " " + l + " " + c + " " + a.imageBaseAttribute), f !== C && t.removeAttr(f)), t.data(d, !0), y(T, t), h.remove(), p() }); var m = (L && A ? A : t.attr(u)) || ""; h.attr(C, t.attr(f)).attr(F, t.attr(l)).attr(E, m ? r + m : null), h.complete && h.trigger(D) } } function A(t) { var e = t.getBoundingClientRect(), r = a.scrollDirection, n = a.threshold, i = h() + n > e.top && -n < e.bottom, o = g() + n > e.left && -n < e.right; return "vertical" === r ? i : "horizontal" === r ? o : i && o } function g() { return w >= 0 ? w : w = n(t).width() } function h() { return B >= 0 ? B : B = n(t).height() } function m(t) { return t.tagName.toLowerCase() } function b(t, e) { if (e) { var r = t.split(","); t = ""; for (var a = 0, n = r.length; a < n; a++)t += e + r[a].trim() + (a !== n - 1 ? "," : "") } return t } function v(t, e) { var n, i = 0; return function (o, u) { function l() { i = +new Date, e.call(r, o) } var f = +new Date - i; n && clearTimeout(n), f > t || !a.enableThrottle || u ? l() : n = setTimeout(l, t - f) } } function p() { --z, i.length || z || y("onFinishedAll") } function y(t, e, n) { return !!(t = a[t]) && (t.apply(r, [].slice.call(arguments, 1)), !0) } var z = 0, w = -1, B = -1, L = !1, T = "afterLoad", D = "load", I = "error", N = "img", E = "src", F = "srcset", C = "sizes", O = "background-image"; "event" === a.bind || o ? f() : n(t).on(D + "." + l, f) } function a(a, o) { var u = this, l = n.extend({}, u.config, o), f = {}, c = l.name + "-" + ++i; return u.config = function (t, r) { return r === e ? l[t] : (l[t] = r, u) }, u.addItems = function (t) { return f.a && f.a("string" === n.type(t) ? n(t) : t), u }, u.getItems = function () { return f.g ? f.g() : {} }, u.update = function (t) { return f.e && f.e({}, !t), u }, u.force = function (t) { return f.f && f.f("string" === n.type(t) ? n(t) : t), u }, u.loadAll = function () { return f.e && f.e({ all: !0 }, !0), u }, u.destroy = function () { return n(l.appendScroll).off("." + c, f.e), n(t).off("." + c), f = {}, e }, r(u, l, a, f, c), l.chainable ? a : u } var n = t.jQuery || t.Zepto, i = 0, o = !1; n.fn.Lazy = n.fn.lazy = function (t) { return new a(this, t) }, n.Lazy = n.lazy = function (t, r, i) { if (n.isFunction(r) && (i = r, r = []), n.isFunction(i)) { t = n.isArray(t) ? t : [t], r = n.isArray(r) ? r : [r]; for (var o = a.prototype.config, u = o._f || (o._f = {}), l = 0, f = t.length; l < f; l++)(o[t[l]] === e || n.isFunction(o[t[l]])) && (o[t[l]] = i); for (var c = 0, s = r.length; c < s; c++)u[r[c]] = t[0] } }, a.prototype.config = { name: "lazy", chainable: !0, autoDestroy: !0, bind: "load", threshold: 500, visibleOnly: !1, appendScroll: t, scrollDirection: "both", imageBase: null, defaultImage: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==", placeholder: null, delay: -1, combined: !1, attribute: "data-src", srcsetAttribute: "data-srcset", sizesAttribute: "data-sizes", retinaAttribute: "data-retina", loaderAttribute: "data-loader", imageBaseAttribute: "data-imagebase", removeAttribute: !0, handledName: "handled", loadedName: "loaded", effect: "show", effectTime: 0, enableThrottle: !0, throttle: 250, beforeLoad: e, afterLoad: e, onError: e, onFinishedAll: e }, n(t).on("load", function () { o = !0 }) }(window);

	$('img.lazy').lazy({
		effect: "fadeIn",
		effectTime: 500,
		threshold: 0
	});




	// Teknik Destek Formu

	$("#teknikDestekButonu").click(function () {
		$("#teknikDestekFormu").fadeIn();
		$(this).html("Lütfen aşağıdaki formu doldurun.");
	});


	// Sepete Ekle

	$(".woocommerce form.cart button.button").html('<span class="safiricon icon"><svg class="safiricon-sepeteekle"><use href="#safiricon-sepeteekle"></use></svg></span>Sepete Ekle');

	$("#productLeft .woocommerce-notices-wrapper").prependTo($(".productContainer")).fadeIn();

	$("form.cart").prependTo(".satisAktif .themeDemo");
	$(".satisAktif form.cart").fadeIn();

	$('form.cart').on('keyup keypress', function (e) {
		var keyCode = e.keyCode || e.which;
		if (keyCode === 13) {
			e.preventDefault();
			return false;
		}
	});

	if ($("body").hasClass("postid-162") || $("body").hasClass("postid-18824")) {
		$("form.cart button").show();
	} else {
		$("form.cart button").hide();
		$('<div class="safirButton sepet color2"><span class="safiricon icon"><svg class="safiricon-sepeteekle"><use href="#safiricon-sepeteekle"></use></svg></span>Sepete Ekle</a>').appendTo($("form.cart"));
	}

	$("form.cart input[name=domain]").on("keyup", function () {
		console.log($("form.cart input[name=domain]").val())
		prepareDomain();
		if (frmValidate($("form.cart input[name=domain]").val())) {
			$("form.cart button").show();
			$("form.cart .safirButton").hide();
		} else {
			$("form.cart button").hide();
			$("form.cart .safirButton").show();
		}
	});

	function prepareDomain() {
		var current = $("form.cart input[name=domain]").val();
		current = current.toLowerCase();
		current = current.replace(" ", "");
		current = current.replace("www.", "");
		current = current.replace("http://", "");
		current = current.replace("https://", "");
		current = current.replace("/", "");
		$("form.cart input[name=domain]").val(current);
	}

	var domainUyari1 = "Temalar domain adresine lisanslanmaktadır ve sipariş onayı sonrasında domain adresi değiştirilememektedir.<div style=height:10px></div><b>siteadresi.com</b> formatında ana domain adresinizi giriniz.";

	var domainUyari2 = "Subdomain veya alt klasör belirtmeksizin sadece <b>siteadresi.com</b> formatında ana domain adresinizi giriniz.<div style=height:10px></div>Ana domain altında alt klasör veya subdomaine de kurabilirsiniz.<div style=height:10px></div>Türkçe domaininiz varsa xn--a-eja.com şeklinde giriş yapınız.<div style=height:10px></div><i>Sipariş onayı sonrasında domain adresi değiştirilememektedir.</i>";

	$("form.cart .safirButton").click(function (e) {
		if ($("form.cart input[name=domain]").val() == "") {
			Swal.fire({
				title: "Domain Adresinizi Giriniz",
				html: domainUyari1,
				icon: "error",
				confirmButtonText: "Kapat"
			});
		} else {
			if (frmValidate($("form.cart input[name=domain]").val())) {
				$("form.cart").submit();
			} else {
				Swal.fire({
					title: "Domain Adresiniz Geçersiz",
					html: domainUyari2,
					icon: "error",
					confirmButtonText: "Kapat"
				});
			}
		}
	});

	function frmValidate(val) {
		if (val.slice(-6) == "k12.tr") {
			return true;
		} else {
			//var re = new RegExp(/^(?!:\/\/)([a-zA-Z0-9]+\.)?[a-zA-Z0-9][a-zA-Z0-9-]+\.[a-zA-Z]{2,10}?$/i);
			var re = new RegExp(/(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/i);
			return val.match(re);
		}
	}

// Safır Icons
	
	function safirIcon(icon = "liste") {
		return '<span class="safiricon icon"><svg class="safiricon-'+icon+'"><use href="#safiricon-'+icon+'"></use></svg></span>';
	}

	$("ul.ullist.tick li, footer .menu li a").prepend(safirIcon("tick"));
	$("#productContent .featured-list.icon-plus li").prepend(safirIcon("list-plus"));
	
	$(".woocommerce div.product .woocommerce-tabs .reviews_tab a").prepend(safirIcon("yorumlar"));
	$(".woocommerce div.product .woocommerce-tabs .version_tab_tab a").prepend(safirIcon("versiyon"));
	$(".woocommerce div.product .woocommerce-tabs .payment_tab_tab a").prepend(safirIcon("lira"));
	$(".woocommerce div.product .woocommerce-tabs .faq_tab_tab a").prepend(safirIcon("soru2"));

// Contact Form 7
		
	document.addEventListener('wpcf7invalid', function (event) {
		Swal.fire({
			title: "Hata",
			html: event.detail.apiResponse["message"],
			icon: "error",
			confirmButtonText: "Kapat"
		});
	}, false);
	/*
	document.addEventListener( 'wpcf7mailfailed', function( event ) {
		$('.wpcf7-response-output').addClass('alert alert-warning');
	}, false );
	*/
	document.addEventListener( 'wpcf7mailsent', function( event ) {
		Swal.fire({
			title: "Mesajınız Alındı",
			html: event.detail.apiResponse["message"],
			icon: "success",
			confirmButtonText: "Tamam"
		});
		$(".oneriButton, .oneriFormContainer").fadeOut()
	}, false);

// Öneri Form
	
	$(".oneriButton").on("click", function () {
		$(".oneriFormContainer").fadeIn()
	})
	
// Product Content
	
	$('head').append('<style class="theme-specs"></style>')

	$("#productContent .theme-specs p").each(function () {
		let iconClass = $(this).attr("class")
		$("style.theme-specs").append(`
		#productContent .theme-specs p.${iconClass}:before {
			background-image: url("https://safirtema.com/wp-content/themes/safirtemav3/images/theme-specs/${iconClass}.svg");
		}
		`)
	})

	// Header Customer Menu

	$("body.logged-in .menuRight .account").on("click", function (e) {
		e.preventDefault()
		$(".header-customer-menu").stop().fadeToggle(350);
	});

	$("#menu .menu-item-has-children a").on("mouseover", function () {
		$(".header-customer-menu").fadeOut(350);
	});

	$(document).on("mouseup", function(e) {
		var container = $(".header-customer-menu");
		if (!container.is(e.target) && container.has(e.target).length === 0) {
			container.fadeOut(350);
		}
	});


// end	
});


